import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LeftOutlined,
  FolderOpenOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Notiflix from "notiflix";
import { connect, useDispatch } from "react-redux";

import {
  DatePicker,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Col,
  Form,
  Table,
  Tooltip,
  Divider,
  Button,
  Anchor,
  Descriptions,
  Spin,
  Statistic,
} from "antd";

//OTHER IMPORTS
import dayjs from "dayjs";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../configurations/configurations.config";
import { rightAction } from "../../../redux/actions";
import CustomButton from "../../../components/custom/CustomButton";

const { Link } = Anchor;
const { Text } = Typography;

const EditSchedulerJobs = (props) => {
  const { userData } = props;
  const { session } = userData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [schedulerJobsDetail, setSchedulerJobsDetail] = useState([]);

  useEffect(() => {
    getDetailById();
  }, []);

  function getDetailById() {
    const url = `${apiConfig.Jobs}/${state.id}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);
        const objList = res;
        setSchedulerJobsDetail(objList);

        useForm.setFieldsValue({
          displayName: objList?.displayName,
          cronExpression: objList?.cronExpression,
          active: objList?.active,
        })
      }
    });
  }

  function onCancel() {
    navigate("/manage-scheduler-jobs");
  }

  function onSubmit(formValues) {

    const url = `${apiConfig.Jobs}/${state.id}`;

    let body = {
      ...formValues,
      session,
      method: "PUT"
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.editSchedulerJobsMsg);
        navigate("/manage-scheduler-jobs");
        setIsLoading(false);
      }
    });
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.editSchedulerJobs}
        pageItems={staticConfig.editSchedulerJobsBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.jobName}
                  name="displayName"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.jobName
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.cronExpression}
                  name="cronExpression"
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.cronExpression
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.isActiveJob}
                  name="active"
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      `${"Option"}`,
                      "select"
                    )}
                    options={staticConfig.yesOrNo}
                  // onChange={handleUseBorrowerCycle}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />

              {
                // BOM.HasPermission("CREATE_STAFF") && 
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default EditSchedulerJobs;
